<div class="dropdown text-{{textAlign}}" [class.w-100]="!!w">
  @if (!!title) {
    <div class="dropdown-title">
      <span class="label-small" [attr.id]="labelId">{{ title }}</span>
    </div>
  }

  <div
    #trigger
    class="box-info"
    [tabindex]="disabled ? -1 : 0"
    role="button"
    [attr.aria-expanded]="isExpanded"
    [attr.aria-haspopup]="'listbox'"
    [attr.aria-controls]="dropdownId"
    [attr.aria-disabled]="disabled ? true : null"
    [attr.aria-required]="required ? true : null"
    [attr.aria-labelledby]="title ? labelId : null"
    [attr.aria-label]="!title ? (placeholder || 'Seleziona') : null"
    [ngClass]="{
      'expanded' : isExpanded,
      'sizeS': size === 's',
      'disabled': disabled,
      'readonly': disableInputOnly,
      'alternative': alternative,
      'w-max': !!w,
      'grey':border,
      'mt8':marginTop,
      'laterale':padding
     }"
    (click)="toggleDropdown()"
    (keydown)="onTriggerKeydown($event)"
  >
    <span class="caption">
      {{ isExpanded ? '' : valoreSelezionato ? valoreSelezionato + ( unitaMisura ? unitaMisura : '' ) : defaultValue || placeholder || '' }}
    </span>

    <!-- FRECCIA PER APRIRE IL DROPDOWN -->
    @if (!disabled && !disableInputOnly) {
      <div class="dropdown-arrow-container">
        <img
          class="dropdown-arrow"
          [class.reverse]="isExpanded"
          ngSrc="/icon/dropdown-arrow.svg"
          alt=""
          width="22"
          height="22"
        >
      </div>
    }
  </div>

  @if (isExpanded) {
    <div
      class="dropdown-content"
      role="listbox"
      [attr.id]="dropdownId"
      [attr.aria-labelledby]="labelId"
      [ngClass]="{'sizeS': size === 's', 'w-max': !!w, 'w-100': !!w}"
    >
      @for (valori of listaValori; let i = $index; track i) {
        <div
          #optionEl
          class="dropdown-value"
          role="option"
          tabindex="-1"
          [attr.id]="optionId(i)"
          [attr.aria-selected]="valoreSelezionato === valori"
          (click)="sceltaValore(valori)"
          (keydown)="onOptionKeydown($event, i)"
        >
          <span class="label-small">{{ valori + ( unitaMisura ? unitaMisura : '' ) }}</span>
        </div>
      }
    </div>
  }
</div>
